import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { Location } from 'vue-router'
import Product from '~/types/api/Product'
import ArrowSvg from '~/assets/svg/arrow-slider.svg?inline'
import s from '~/utils/s'
import { SliderSlick } from '~/types/Slider'
import ProductCardAnalogs from '~/components/element/ProductCardAnalogs'

@Component({
  components: {
    ProductCardAnalogs
  }
})
export default class ProductSlidesAnalogs extends Vue {
  @Prop({ type: Array, default: [] })
  readonly products!: Product[]

  @Prop({ type: String, default: 'Товары' })
  readonly title!: string

  @Prop({ type: String, default: 'Все товары' })
  readonly linkTitle!: string

  @Prop({ default: '/' })
  readonly location!: Location

  @Prop({ type: Boolean, default: true })
  readonly isShowButton!: boolean

  @Prop({ type: Boolean, default: true })
  readonly isShowHead!: boolean

  @Ref()
  readonly Slider!: SliderSlick

  options = {
    slidesToShow: 4,
    arrows: false,
    // slidesToScroll: 10,
    dots: false,
    infinite: true,
    speed: 250,
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  }

  currentSlide: number = 0

  get count (): number {
    return this.products.length
  }

  get productList (): Product[] {
    return this.products
  }

  get code (): string {
    return JSON.stringify(this.products)
  }

  next () {
    this.Slider.next()
  }

  prev () {
    this.Slider.prev()
  }

  change (index: number) {
    this.currentSlide = index
  }

  getProducts (e: Product, index: number) {
    return (
      <div key={e.id} class="product-slides__item">
        <product-card-analogs product={e} position={index}/>
      </div>
    )
  }

  renderButtonLink () {
    if (this.isShowButton) {
      return (
        <div>
          <nuxt-link class="product-slides__link" to={this.location}>
            {this.linkTitle}
          </nuxt-link>
          <nuxt-link class="product-slides__link-mobile" to={this.location}>
            Все
          </nuxt-link>
        </div>
      )
    }
  }

  render () {
    const link = s(this.$store).general.host + this.$route.fullPath
    return (
      <div class="product-slides analog">
        {this.isShowHead &&
        <div class="product-slides__top">
          <h2 class="product-slides__header">
            {this.title}
          </h2>
          {this.renderButtonLink()}
        </div>
        }
        <div class="product-slides__track-wrapper" itemscope itemtype="https://schema.org/ItemList">
          <meta itemprop="url" content={link}/>
          <meta itemprop="numberOfItems" content={this.count}/>
          <div class="product-slides__track">
            <client-only>
              <vue-slick-carousel ref="Slider" 
                onAfterChange={this.change}
                slidesToShow={this.options.slidesToShow}
                infinite={this.options.infinite}
                navButtons={this.options.arrows}
                dots={this.options.dots}
                arrows={this.options.arrows}
                draggable={(this as any).$mq === 'sm'}
                onInit={() => { }}
                responsive = {this.options.responsive}>
                {this.productList.map((e: Product, index: number) => this.getProducts(e, index))}
              </vue-slick-carousel>
            </client-only>
          </div>
          <div {...{
            class: {
              'product-slides__nav-wrapper': true,
              'product-slides__nav-wrapper_hide': this.products.length <= 4
            }
          }}>
            <div class="product-slides__nav">
              <div class="product-slides__nav-prev" onClick={this.prev}>
                <ArrowSvg/>
              </div>
              <div class="product-slides__nav-next" onClick={this.next}>
                <ArrowSvg/>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
